import { getTheme } from 'themes'

/** The chart tooltip's card, shared by every tooltip that shows data. */
export const getDataTooltipSurface = () => {
  const theme = getTheme('light')

  return {
    background: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(12px)',
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: '8px',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily as string,
    fontSize: theme.typography.body1['fontSize'] as string,
    padding: '8px 10px'
  }
}
